'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ckeditor = require('./ckeditor');

var _ckeditor2 = _interopRequireDefault(_ckeditor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = _ckeditor2["default"];
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-ckeditor-wrapper/lib/index.js
// module id = 142
// module chunks = 0